import api from './api';
import { AppUser } from '../types';

export interface CreateUserPayload {
  email: string;
  password: string;
  nombre: string;
  role?: 'ADMIN' | 'SUPERVISOR' | 'AGENTE';
  empresaId?: string;
}

export const getUsers = () => api.get<AppUser[]>('/users');
export const createUser = (data: CreateUserPayload) => api.post<AppUser>('/users', data);
export const updateUser = (id: string, data: Partial<CreateUserPayload> & { activo?: boolean }) =>
  api.patch<AppUser>(`/users/${id}`, data);
